export default "__VITE_ASSET__D48cxQ2N__"